import axios from 'axios';

export function uuidv4() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        // eslint-disable-next-line no-mixed-operators
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    )
}

export const makeRequest = (url, clientId, method, params, jsonParams, successFn, errorFn) => {

    const client = axios.create({
        baseURL: url,
        headers: {
            'Content-Type': 'application/json'
        }
    });

    console.log({
        methodName : method,
        params: {
            ...params,
            jsonMesg: JSON.stringify(jsonParams)
        }
    });

    //axios
    client
        .post(url, {
            id: clientId,
            method: method,
            params: {
                ...params,
                jsonMesg: JSON.stringify(jsonParams)
            }
        })
        .then(response => {
            let clientID = response.data.id;
            let method = JSON.parse(response.config.data).method;
            let params = JSON.parse(response.config.data).params;
            let result = response.data.result;

            if (result === 'undefined') {
                result = undefined;
            }
            else if ((typeof result === 'string') && (result.charAt(0) === '{')) {
                result = JSON.parse(response.data.result);
            }
            else {
                result = response.data.result;
            }

            let output = {};
            output.methodName = method;
            output.params = params;
            output.result = result;
            console.log(output);

            if (typeof successFn !== 'undefined') {
                successFn(result, clientID);
            }
        })
        .catch(function (error) {
            if (typeof error.response === 'undefined') {

                switch (error.message) {
                    case "Network Error" :
                        alert('The server may be unavailable at this time.');
                        break;

                    default:
                        alert('An error has occured with communicating to the server.');
                        console.error(error);
                        break;
                }

                // console.error('Client/server connection was not made! The server may be unavailable at this time.');
                // console.log('Here is the error:');
                // console.warn(error);
            }
            else {
                let errorMsg =  JSON.parse(error.response.request.response).error.message;
                console.warn('Error returned from the server: ' + errorMsg);
                if (typeof errorFn !== 'undefined') {
                    errorFn();
                }
            }
        });
};


// WEBPACK FOOTER //
// ./src/api/makeRequest.js